import { render } from "./mentalHealthVideoManager.vue?vue&type=template&id=31e0d8d2&scoped=true"
import script from "./mentalHealthVideoManager.vue?vue&type=script&lang=js"
export * from "./mentalHealthVideoManager.vue?vue&type=script&lang=js"

import "./mentalHealthVideoManager.vue?vue&type=style&index=0&id=31e0d8d2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e0d8d2"]])

export default __exports__